import { MapboxOverlay, MapboxOverlayProps } from "@deck.gl/mapbox";
import React, { ReactNode, useEffect, useRef } from "react";
import Map, { MapProps, useControl } from "react-map-gl/maplibre";
import "maplibre-gl/dist/maplibre-gl.css";

function DeckGLOverlay(
  props: MapboxOverlayProps & {
    interleaved?: boolean;
  }
) {
  const { id } = props;
  const savedId = useRef(id).current;
  useEffect(() => {
    if (id !== savedId) console.warn("Map id changed. It shouldn't because now useMap won't work.");
  }, [id, savedId]);

  const overlay = useControl<MapboxOverlay>(() => new MapboxOverlay(props));
  overlay.setProps(props);
  return null;
}

export type MapDeckGlProps = {
  id?: string;
  mapProps: Omit<MapProps, "id">;
  deckGlProps?: Omit<MapboxOverlayProps, "id">;
  children?: ReactNode;
};

export const MapDeckGl: React.FC<MapDeckGlProps> = ({ id, mapProps, deckGlProps, children }) => {
  const hasDeckGlProps = !!deckGlProps && Object.keys(deckGlProps).length > 0;
  return (
    <Map id={id} {...mapProps}>
      {/* Only bother actually rendering the deck.gl overlay if we are actually using it */}
      {hasDeckGlProps && <DeckGLOverlay id={id} {...deckGlProps} />}
      {children}
    </Map>
  );
};
